import $ from 'jquery';
import GroupedContent from 'grouped-content';

export default class RTE {
  constructor() {
    this.groupedContents = [];
    this.$rteContainers = $('.rte');

    this._init();
  }

  _init() {
    this.$rteContainers.each((index, rteContainer) => {
      this.groupedContents.push(new GroupedContent(rteContainer, { layout: 'accordion', intelliparse: false }));
    });
  }
}
